export default {
  merchant_type_1: 'Personal',
  merchant_type_2: 'Business',
  merchant_status_1: 'Valid',
  merchant_status_2: 'Invalid',
  merchant_origin_1: 'Direct sign',
  merchant_origin_2: 'Agent sign',
  id_num_type_1: 'National ID(Recommend)',
  id_num_type_2: 'Driver\\’s License',
  id_num_type_3: 'Passport',
  id_num_type_4: 'Postal ID',
  id_num_type_5: 'PRC (Professional ID Card)',
  id_num_type_6: 'Social Security System (SSS) ID’',
  id_num_type_7: 'UMID (Unified Multi-Purpose ID)',
  id_num_type_8: 'Voter\\’s ID',
  id_num_type_9: 'PhilHealth ID',
  id_num_type_10: 'Taxpayer Identification Number(TIN) ID',
  fee_type_1: 'Floated fee',
  fee_type_2: 'Fixed amount',
  fee_structure_1: 'Flat rate',
  fee_structure_2: 'Step rate',
  merchant_product_1: 'Payin',
  merchant_product_2: 'Payout',
  merchant_product_4: 'Refund',
  pay_trans_status_1: 'Unpaid',
  pay_trans_status_2: 'Success',
  pay_trans_status_3: 'Failed',
  pay_trans_status_4: 'Void',
  pay_trans_status_5: 'Voiding',
  po_trans_status_0: 'Creating',
  po_trans_status_1: 'Pending',
  po_trans_status_2: 'Pending',
  po_trans_status_3: 'Success',
  po_trans_status_4: 'Failed',
  po_trans_status_5: 'Pending',
  po_trans_status_99: 'Refund Completed',
  refunding_status_0: 'Waiting for refund',
  refunding_status_1: 'Refunding',
  refunding_status_2: 'Refund successful',
  refunding_status_3: 'Refund failed',
  refunding_status_4: 'Partial refunding',
  refunding_status_5: 'Partial refund successful',
  refunding_status_6: 'Refund cancel',
  repayment_status_1: 'Pending',
  repayment_status_2: 'Complete',
  repayment_status_3: 'Failed',
  repayment_status_4: 'Closed',
  withdraw_trans_status_4: 'Unprocessed',
  withdraw_trans_status_1: 'Processing',
  withdraw_trans_status_2: 'Success',
  withdraw_trans_status_3: 'Failed',
  withdraw_trans_status_5: 'Waiting for Retry',
  withdraw_trans_status_6: 'Retrying',
  withdraw_trans_status_7: 'Quoting',
  withdraw_trans_status_8: 'Confirming',
  balance_type_1: 'Payin',
  balance_type_2: 'Payout',
  balance_type_3: 'Top Up',
  balance_type_4: 'Cash Out',
  balance_type_5: 'Pay Out(Fail) Refund',
  balance_type_6: 'Related Transfer In',
  balance_type_7: 'Related Transfer Out',
  balance_type_8: 'D0 Payin',
  balance_type_9: 'Frozen Amount',
  balance_type_10: 'Unfrozen Amount',
  balance_type_11: 'Reversal',
  balance_type_12: 'Reversal transfer in',
  balance_type_13: 'Abnormal Adjustment - Credit',
  balance_type_14: 'Abnormal Adjustment - Debit',
  balance_type_15: 'Payin Commission Settlement',
  balance_type_16: 'Payout Commission Settlement',
  balance_type_17: 'Commission Debited (Reserval)',
  balance_type_18: 'Commission Debited (Payout Fail Refund)',
  balance_type_19: 'Refund After Payment',
  balance_type_20: 'Payment Refund Failed',
  balance_type_21: 'Commission Deduction (Payment Refund)',
  balance_type_22: 'Cash Out Fail',
  balance_type_23: 'FX Transfer Out',
  balance_type_24: 'FX Transfer In',
  balance_type_25: 'FX Reversal Transfer Out',
  balance_type_26: 'FX Reversal Transfer In',
  balance_type_27: 'Db Payin',
  balance_type_28: 'NSDS recharge',
  balance_type_29: 'NSDS Fee Pay',
  balance_type_30: 'NSDS Fee Pay Refund',
  balance_type_31: 'Split Payout',
  balance_type_32: 'Split Payin',
  balance_type_33: 'Split Return Payout',
  balance_type_34: 'Split Return Payin',
  balance_type_35: 'Early Settlement Fee',
  balance_type_36: 'Account Validation Fee',
  balance_type_37: 'Account Validation Refund',
  balance_type_38: 'NSDS Deduction',
  balance_type_38_balance_detail: 'NSDS Credit Recycle',
  balance_type_39: 'Payment Slip Validation',
  balance_type_40: 'Payment Slip Validation Failed Refund',
  funds_source_1: 'Investment',
  funds_source_2: 'Employment',
  funds_source_3: 'Business',
  funds_source_4: 'Inheritance',
  funds_source_99: 'Other',
  recharge_status_1: 'Processing',
  recharge_status_2: 'Success',
  recharge_status_3: 'Failed',
  recharge_status_4: 'Returned',
  transfer_status_0: 'Processing',
  transfer_status_1: 'Success',
  transfer_status_2: 'Failed',
  transfer_record_type_1: 'Transfer Out',
  transfer_record_type_2: 'Transfer In',
  upload_status_1: 'Upload Success',
  upload_status_2: 'Verify Statement',
  deal_status_0: 'unVerify',
  deal_status_1: 'unVerify',
  deal_status_2: 'Verifying',
  deal_status_3: 'Verify Complete',
  po_trans_type_1: 'Api Pay Out',
  po_trans_type_2: 'File Batch Pay Out',
  po_trans_type_3: 'Cash Out',
  pay_trans_type_1: 'Api Payin',
  pay_trans_type_2: 'Merchant Top Up',
  ticket_status_1: 'Not Processed',
  ticket_status_2: 'Processing',
  ticket_status_3: 'Processed',
  large_payment_status_1: 'Processing',
  large_payment_status_2: 'Success',
  large_payment_status_3: 'Failed',
  large_payment_status_4: 'Refund successfully',
  institute_type_1: 'Payin Institution',
  institute_type_2: 'Payout Institution',
  institute_rate_type_1: 'Fixed amount',
  institute_rate_type_2: 'Flat percent',
  institute_rate_type_3: 'Tiered fixed amount',
  institute_rate_type_4: 'Tiered flat percent',
  institute_rate_type_5: 'The smaller from fixed amount and flat percent',
  institute_rate_type_6: 'The greater from fixed amount and flat percent',
  action_type_1: 'Debit',
  action_type_2: 'Credit',
  channel_code_1: 'GCASH_STATIC_VA',
  channel_code_2: 'PAYMAYA_STATIC_VA',
  channel_code_3: '7ELEVEN_STATIC_VA',
  channel_code_4: 'MLH_STATIC_VA',
  channel_code_5: 'RDP_STATIC_VA',
  channel_code_6: 'QRPH_STATIC_QR',
  channel_code_7: 'QRPH_DYNAMIC_QR',
  channel_code_8: 'QRPH_HYBRID_QR',
  channel_code_9: 'INSTA_TRANSFER_ACC',
  channel_code_10: 'PESONET_TRANSFER_ACC',
  settlement_type_1: 'Automatic Settlement',
  settlement_type_2: 'Manually Settlement',
  withdraw_type_1: 'Manually Withdraw',
  withdraw_type_2: 'Automatic Withdraw',
  auto_withdraw_type_1: 'Period',
  auto_withdraw_type_2: 'Fixed Amount',
  va_account_aduit_status_1: 'Unapproved',
  va_account_aduit_status_2: 'Approved',
  va_account_aduit_status_3: 'Rejected',
  switch_status_1: 'Enable',
  switch_status_2: 'Close',
  mch_audit_status_1: 'Pending',
  mch_audit_status_2: 'Modify',
  mch_audit_status_3: 'Rejected',
  mch_audit_status_4: 'Approved',
  read_flag_1: 'Unread',
  read_flag_2: 'Read',
  jt_order_status_1: 'Pending',
  jt_order_status_2: 'Paid',
  jt_order_status_3: 'Canceled',
  beneficiary_audit_1: 'Reviewing',
  beneficiary_audit_2: 'Approved',
  beneficiary_audit_3: 'Rejected',
  beneficiary_audit_4: 'Returned',
  beneficiary_audit_5: 'Expired',
  single_payout_payment_type_1: 'Small-value Payment',
  single_payout_payment_type_2: 'Large-value Payment',
  transaction_settlement_status_1: 'Settled',
  transaction_settlement_status_2: 'Pending',
  checkout_status_1: 'unpaid',
  checkout_status_2: 'paid',
  checkout_status_3: 'closed',
  fx_transaction_type_1: 'FX',
  fx_transaction_type_2: 'FX Reversal',
  common_status_1: 'Pending',
  common_status_2: 'Success',
  common_status_3: 'Failure',
  beneficiary_account_type_0: 'Bank',
  beneficiary_account_type_1: 'Promptpay',
  beneficiary_account_type_2: 'E-Wallet',
  beneficiary_account_type_3: 'SBP',
  beneficiary_type_0: 'National ID',
  beneficiary_type_1: 'Mobile Number',
  beneficiary_type_2: 'Bank Account',
  beneficiary_type_3: 'Card Number',
  loan_status_1: 'Pending Review',
  loan_status_2: 'Pending Disbursement',
  loan_status_3: 'Disbursed',
  loan_status_4: 'Transaction Rejected',
  loan_type_1: 'Consumer Loan',
  loan_type_2: 'Cash Loan',
  repay_method_1: 'Manual Repayment',
  repay_method_2: 'Auto Debit',
  repay_method_3: 'Hybrid Repayment',
  bill_status_2: 'Pending',
  bill_status_3: 'Completed',
  bill_status_4: 'Overdue',
  loan_bill_status_1: 'Repaying',
  loan_bill_status_2: 'Completed',
  loan_bill_status_3: 'Overdue',
  credit_debit_1: 'Credit',
  credit_debit_2: 'Debit',
  benefit_address: 'Beneficiary Address',
  checkout_order_status_1: 'Pending',
  checkout_order_status_2: 'Paid',
  checkout_order_status_3: 'Closed',
  receiver_relation_map_1: 'Service Provider',
  receiver_relation_map_2: 'Store',
  receiver_relation_map_3: 'Employee',
  receiver_relation_map_4: 'Shopkeeper',
  receiver_relation_map_5: 'Partner',
  receiver_relation_map_6: 'Headquarters',
  receiver_relation_map_7: 'Brand Owner',
  receiver_relation_map_8: 'Distributor',
  receiver_relation_map_9: 'User',
  receiver_relation_map_10: 'Supplier',
  receiver_relation_map_11: 'Customize',
  receiver_type_map_1: 'PayCools Merchant',
  receiver_type_map_2: 'Bank Account',
  receiver_type_map_3: 'E-Wallet',
  split_status_map_1: 'Pending',
  split_status_map_2: 'Success',
  split_status_map_3: 'Failed',
  authorization_status_1: 'Unauthorized',
  authorization_status_2: 'Authorized',
  card_account_status_1: 'Active',
  card_account_status_2: 'Inactive',
  card_account_status_3: 'Frozen',
  card_account_status_4: 'Closed',
  card_order_status_0: 'Pending',
  card_order_status_1: 'Processing',
  card_order_status_2: 'Success',
  card_order_status_3: 'Failed',
  card_name_match_result_0: 'Unchecked',
  card_name_match_result_1: 'Match',
  card_name_match_result_2: 'Mismatch',
  card_account_type_1: 'Bank Account',
  card_account_type_2: 'E-Wallet',
  template_type_1: 'Channel Maintenance',
  template_type_2: 'Holiday Schedule',
  template_type_3: 'Risk Order',
  template_type_4: 'Fee Adjustment',
  template_type_5: 'Balance Alert',
  template_type_6: 'Card Dispute',
  template_type_99: 'Other',
  template_type_1_desc: 'Channel status changes, maintenance notices, etc.',
  template_type_2_desc: 'Holiday notices, rest schedules, etc.',
  template_type_3_desc: 'Risk control order processing notices',
  template_type_4_desc: 'Fee adjustment notices',
  template_type_5_desc: 'An email will be sent when the balance falls below the alert amount. “In-app Notifications” only controls in-app notifications for this account and does not affect emails. To disable the alert, clear the amount.',
  template_type_5_desc_sub: 'The alert amount is configured by the primary account.',
  template_type_6_desc: 'Dispute processing related notices',
  template_type_99_desc: 'Other type notifications'
}
